var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTennisBall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 477 477",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #86efac;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M460.39,326.12c-16.02-3.99-32.63-6.04-49.57-6.04-54.37,0-105.49,21.17-143.94,59.62-26.86,26.86-45.28,59.92-53.95,95.94,8.4.9,16.92,1.37,25.56,1.37,100.78,0,186.97-62.51,221.89-150.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M410.82,285.13c20.72,0,40.81,2.65,59.98,7.61,4.05-17.42,6.2-35.58,6.2-54.24,0-110.43-75.07-203.32-176.95-230.47-25.24,104.64-119.45,182.39-231.84,182.39-21.28,0-41.91-2.8-61.55-8.03-4.34,18-6.66,36.78-6.66,56.11,0,111,75.83,204.29,178.52,230.89,24.56-105.59,119.24-184.26,232.3-184.26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.14,95.86c26.46-26.46,44.73-58.92,53.56-94.31-8.93-1.01-18-1.55-27.2-1.55C138.4,0,52.71,61.68,17.34,149.1c16.42,4.21,33.47,6.38,50.87,6.38,54.37,0,105.49-21.17,143.94-59.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennisBall);
export default __webpack_public_path__ + "static/media/tennis_ball.6e2e786bfb60f52dabb1e70e3ead01d9.svg";
export { ForwardRef as ReactComponent };